import { startCase, toLower } from 'lodash';
import { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { FieldErrors, FieldValues, useFieldArray } from 'react-hook-form';
import { BsPlus, BsTrash } from 'react-icons/bs';
import { FileUploader, StatusEnum } from '../FileUploader';
import { FormFeedback } from '../FormFeedback';

interface DocumentArrayFieldProps {
  id: string;
  label?: string;
  control: React.ComponentProps<typeof FileUploader>['control'];
  errors: FieldErrors;
  isRequired?: boolean;
  displaySecondaryRemove?: boolean;
  className?: string;
  labelClassName?: string;
}

export const DocumentArrayField = ({
  id,
  label = startCase(toLower(id)),
  control,
  errors,
  isRequired = true,
  displaySecondaryRemove,
  className,
  labelClassName,
}: DocumentArrayFieldProps) => {
  const [shouldHideRemoveBtn, setShouldHideRemoveBtn] = useState<{ [key: string]: boolean }>({});
  const {
    fields: documentArrayFields,
    append: addDocument,
    remove: removeDocument,
  } = useFieldArray<FieldValues, string, 'id' | 'file'>({
    control,
    name: id,
  });

  const onStatusChange = (
    status: StatusEnum,
    id: string,
    shouldShowRemoveBtn: { [key: string]: boolean }
  ) => {
    setShouldHideRemoveBtn({
      ...shouldShowRemoveBtn,
      [id]: status === StatusEnum.COMPLETED || status === StatusEnum.IN_PROGRESS,
    });
  };

  return (
    <Form.Group controlId={id} className={className}>
      <Form.Label className={labelClassName}>
        {label}
        {isRequired && <span className="text-danger"> *</span>}
      </Form.Label>
      <FormFeedback clientError={errors?.[id]} />
      {documentArrayFields.map((field, index) => (
        <div key={field.id}>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <FileUploader
              name={`${id}.${index}.file`}
              containerClassName="w-100 ,"
              control={control}
              dest="providers_documents"
              required={false}
              isClearable={!displaySecondaryRemove}
              isInvalid={!!errors.misc_files?.[index]}
              onRemove={() => removeDocument(index)}
              onStatusChange={(status) => onStatusChange(status, field.id, shouldHideRemoveBtn)}
            />
            {(!shouldHideRemoveBtn[field.id] || displaySecondaryRemove) && !field.file && (
              <BsTrash className="ms-2 remove-btn" onClick={() => removeDocument(index)} />
            )}
          </div>
          <FormFeedback clientError={errors?.[id]?.[index]} />
        </div>
      ))}
      <Button
        className="d-flex align-items-center"
        type="button"
        variant="outline-primary"
        onClick={() => addDocument({ file: null })}
      >
        <BsPlus className="me-1" /> Add Document
      </Button>
    </Form.Group>
  );
};
